import MuiStep from "@mui/material/Step";
const Step = MuiStep;
export default Step;
